import { render } from "./FutureRewards.vue?vue&type=template&id=473960d4&scoped=true"
import script from "./FutureRewards.vue?vue&type=script&lang=js"
export * from "./FutureRewards.vue?vue&type=script&lang=js"

import "./FutureRewards.vue?vue&type=style&index=0&id=473960d4&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-473960d4"]])

export default __exports__